class Product{constructor(){this.acc=[],this.container=document.querySelector(".m-main-product"),MinimogTheme.CompareProduct&&MinimogTheme.CompareProduct.setCompareButtonsState(),MinimogTheme.Wishlist&&MinimogTheme.Wishlist.setWishlistButtonsState(),this.addRecentViewedProduct(),addEventDelegate({context:this.container,selector:(window.__minimog_review_selector||"")+".m-product-collapsible .jdgm-widget-actions-wrapper, .m-product-collapsible .spr-summary-actions-newreview",handler:e=>{const t=e.target.closest(".m-product-collapsible").dataset.index;setTimeout((()=>{this.acc[Number(t)].setContentHeight()}),300)},capture:!0})}addRecentViewedProduct(){const e=getCookie("m-recent-viewed-products");let t=e?JSON.parse(e):[];-1===t.indexOf(MinimogSettings.productHandle)&&(t.unshift(MinimogSettings.productHandle),t=t.slice(0,20),setCookie("m-recent-viewed-products",JSON.stringify(t)))}}

(() => {
  const BUY_NOW_SELECTOR = '[data-product-buy-now]';
  const NATIVE_PAYMENT_SELECTOR = '.shopify-payment-button__button, .shopify-payment-button__more-options';

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(BUY_NOW_SELECTOR);
    if (!(trigger instanceof HTMLElement)) return;
    if (trigger.hasAttribute('disabled') || trigger.classList.contains('disabled')) return;

    const termsWrapper = trigger.closest('[data-terms-action][disabled]');
    if (termsWrapper) return;

    event.preventDefault();

    const checkoutWrapper = trigger.closest('.m-product-dynamic-checkout');
    const nativeButton = checkoutWrapper?.querySelector(NATIVE_PAYMENT_SELECTOR);

    if (nativeButton instanceof HTMLElement) {
      trigger.classList.add('is-loading');
      nativeButton.click();
      window.setTimeout(() => {
        trigger.classList.remove('is-loading');
      }, 1200);
    }
  });
})();
